import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var rotas = [{
  path: '/pesquisa/:identificador',
  name: 'Pesquisa',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./index.vue');
  },
  meta: {
    titulo: 'Pesquisa',
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true,
    ambienteSeguro: true
  }
}];